module.exports = __webpack_public_path__ + "static/arrow-light-0f2b74cc9cbeb8bd399087c30b82fc6f.png";